import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import DialogContentText from '@mui/material/DialogContentText';
import PlatformAgreement from '../PlatformAgreement';

interface LegalModalProps {
  open: boolean;
  onClose: () => void;
}

const LegalModal: React.FC<LegalModalProps> = ({ open, onClose }) => {
  const descriptionElementRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <Dialog maxWidth={'lg'} open={open} onClose={onClose} scroll={'paper'}>
      <DialogTitle>Terms and Conditions</DialogTitle>
      <DialogContent dividers={true}>
        <DialogContentText
          sx={{ color: '#000' }}
          id="scroll-dialog-description"
          ref={descriptionElementRef}
          tabIndex={-1}
        >
          <PlatformAgreement />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LegalModal;
